export default __webpack_public_path__ + "static/media/bongkar-tbs.27a56330.png";